import { darken } from 'polished';

export default function useEventTheme() {
  // This isn't used anyway because of the theme-ui config in the root of the site.
  return {
    colors: {
      primary: '#2D2162',
      secondary: darken(0.1)('#2D2162'),
      accent: '#1B6C8D',
    },
  };
}
